import React, { useState } from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import { UserOutlined, LockOutlined, MailOutlined } from "@ant-design/icons";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const RegisterForm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await axios.post("/api/accounts/register/", {
        first_name: values.first_name,
        last_name: values.last_name,
        username: values.username,
        email: values.email,
        password: values.password,
        password2: values.confirm,
      });

      if (response.status === 200) {
        message.success(
          "Register successfully, please check your email for activation!"
        );
        localStorage.setItem("emailForActivation", values.email);
        form.resetFields();
        navigate("/activation_prompt", { replace: true });
      }
    } catch (error) {
      if (error.response) {
        message.error(`Register failed: ${error.response.data.message}`);
      } else {
        message.error("Network error, please try again!");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" style={{ marginTop: 100 }}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <div style={{ padding: 24, background: "#fff", borderRadius: 4 }}>
          <h2 style={{ textAlign: "center", marginBottom: 24 }}>
            Sign Up Account
          </h2>
          <Form
            form={form}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
            layout="vertical"
            // labelCol={{ flex: "100px" }}
            // wrapperCol={{ flex: "auto" }}
            // labelAlign="left"
          >
            <Form.Item label="Full Name">
              <Form.Item
                style={{
                  display: "inline-block",
                  width: "calc(50% - 4px)",
                  margin: "0 0",
                }}
                name="first_name"
                rules={[
                  {
                    type: "text",
                    message: "First name",
                  },
                  {
                    required: false,
                    message: "Please input your first name!",
                  },
                ]}
              >
                <Input placeholder="Enter First Name" />
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  width: "calc(50% - 4px)",
                  margin: "0 0 0 8px",
                }}
                name="last_name"
                rules={[
                  {
                    type: "text",
                    message: "Last name",
                  },
                  {
                    required: false,
                    message: "Please input your last name!",
                  },
                ]}
              >
                <Input placeholder="Enter Last Name" />
              </Form.Item>
            </Form.Item>
            <Form.Item
              label="User Name"
              name="username"
              rules={[
                {
                  type: "text",
                  message: "Please input your user name!",
                },
                {
                  required: true,
                  message: "Please input your user name!",
                },
              ]}
            >
              <Input prefix={<UserOutlined />} placeholder="Enter user Name" />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="Enter Email" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
                {
                  min: 8,
                  message: "Password must be at least 8 characters",
                },
              ]}
              hasFeedback
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Enter Password"
                autoComplete="new-password"
              />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="confirm"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Confirm Password"
                autoComplete="new-password"
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Register
              </Button>
            </Form.Item>
          </Form>
          <div>
            {/* <Link to="/login">Already have an account? Login</Link> */}
            <Button type="link" onClick={() => navigate("/login")}>
              Already have an account? Login
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default RegisterForm;
